/** DataType indicates how the data is to be understood by any consuming system. */
export enum DataType {
  FORECAST = 1,
  SIMPLE_SCALAR = 2,
  AVERAGE = 5,
  MINIMUM = 6,
  ZONE_TRANSITION_TRIGGER = 10
}

/** Error code for samples */
export enum ErrorCode {
  NO_ERROR = 0,
  MISSING_DATA = 5,
  OUT_OF_RANGE = 10
}